import {Filter} from "./filter-item/filter";
import {FilterPortalConfig} from "../../../../config/filters/filter-portal-config.model";

export class FilterBlock {

  filters: Filter[];

  filterConfig: FilterPortalConfig;

  childFilterBlocks: FilterBlock[] = [];

  childFacetList: Filter[] = [];

  constructor(filterConfig: FilterPortalConfig, filters: Filter[], childFilterBlocks?: FilterBlock[], childFacetList?: Filter[]) {
    this.filterConfig = filterConfig;
    this.filters = filters;
    if (childFilterBlocks) {
      this.childFilterBlocks = childFilterBlocks;
    }
    if (childFacetList) {
      this.childFacetList = childFacetList;
    }
  }

  isDefault(){
    return this.filterConfig.renderer === 'default';
  }

  isPhrase(){
    return this.filterConfig.renderer === 'phrase';
  }

  isSelect(){
    return this.filterConfig.renderer === 'select';
  }

  isRange(){
    return this.filterConfig.renderer === 'range';
  }

  isRangeQuick(){
    return this.filterConfig.renderer === 'range-quick-select';
  }

  isTree(){
    return this.filterConfig.renderer === 'tree';
  }


}
